import {InstrumentItem} from '../../../core/models/InstrumentItem';

export class InstrumentItemImpl implements InstrumentItem {

    rowKey: string;
    modelName: string;
    modelId: string;
    entity: string;

    instrType: string;
    counterParty: string;
    positionDate: string;
    currency: string;
    bondPrice: number;
    bondCurrency: string;
    againstCurrency: string;
    bondMaturityDate: string;
    bondIssueDate: string;
    bondNotional: number;
    fxRate: number;
    repoRate: number;

    leg1MaturityDate: string;
    leg1Notional: number;
    leg1IrsNotional?: number;

    leg1FixedRateCoupon: number;
    leg1Id: string;
    leg1LegType: string;
    leg1Currency: string;
    leg1BondCurrency: string;
    leg1AgainstCurrency: string;
    leg1BondPrice: number;
    leg1BondMaturityDate: string;
    leg1BondIssueDate: string;
    leg1PnlAccounting: number;
    leg1HaircutAfterPricing: number;
    leg1PriceAccounting: number;
    leg1CouponFrequency: number;
    leg1Spread: number;
    leg1RefForward: string;
    leg1Amount: number;
    leg1NpvUsd: number;
    leg1DisCurve: string;
    leg1IssueDate: string;
    leg1PrincipalExchanged: string;

    leg1FloatingRate: number;
    leg1BasicCurve: number;
    leg1PayBackNotional: number;
    leg1ZSpread: number;
    leg1PayNotional: number;
    leg1CounterParty: string;
    leg1BondNotional: number;
    leg1FxRate: number;
    leg1RepoRate: number;


    leg2MaturityDate: string;
    leg2Notional: number;
    leg2IrsNotional?: number;
    leg2FixedRateCoupon: number;
    leg2Id: string;
    leg2LegType: string;
    leg2Currency: string;
    leg2BondCurrency: string;
    leg2AgainstCurrency: string;
    leg2BondPrice: number;
    leg2BondMaturityDate: string;
    leg2BondIssueDate: string;
    leg2PnlAccounting: number;
    leg2HaircutAfterPricing: number;
    leg2PriceAccounting: number;
    leg2CouponFrequency: number;
    leg2Spread: number;
    leg2RefForward: string;
    leg2Amount: number;
    leg2NpvUsd: number;
    leg2IssueDate: string;
    leg2DisCurve: string;
    leg2PrincipalExchanged: string;

    leg2FloatingRate: number;
    leg2BasicCurve: number;
    leg2PayBackNotional: number;
    leg2ZSpread: number;
    leg2PayNotional: number;
    leg2CounterParty: string;
    leg2BondNotional: number;
    leg2FxRate: number;
    leg2RepoRate: number;

    vaR_PLE: number;
    vaR_PFE: number;

    status: string;
    tradeExecuted: boolean;
    createdDate: string;
    lastUpdated: string;
    userName: string;

    accountingValue: number;

    constructor() {
        this.accountingValue = 0;
        this.bondCurrency = '';
        this.againstCurrency = '';
        this.bondIssueDate = '';
        this.bondMaturityDate = '';
        this.bondPrice = 0;
        this.counterParty = '';
        this.createdDate = '';
        this.currency = '';
        this.entity = '';
        this.instrType = '';
        this.lastUpdated = '';
        this.bondNotional = 0;
        this.fxRate = 0;
        this.repoRate = 0;

        this.leg1Amount = 0;
        this.leg1BasicCurve = 0;
        this.leg1BondCurrency = '';
        this.leg1AgainstCurrency = '';
        this.leg1BondIssueDate = '';
        this.leg1BondMaturityDate = '';
        this.leg1BondPrice = 0;
        this.leg1CounterParty = '';
        this.leg1CouponFrequency = 0;
        this.leg1Currency = '';
        this.leg1DisCurve = '';
        this.leg1FixedRateCoupon = 0;
        this.leg1FloatingRate = 0;
        this.leg1HaircutAfterPricing = 0;
        this.leg1Id = '';
        this.leg1IrsNotional = 0;//ATTN
        this.leg1IssueDate = '';
        this.leg1LegType = '';
        this.leg1MaturityDate = '';
        this.leg1Notional = 0;
        this.leg1NpvUsd = 0;
        this.leg1PayBackNotional = 0;
        this.leg1PayNotional = 0;
        this.leg1BondNotional = 0;
        this.leg1FxRate = 0;
        this.leg1RepoRate = 0;
        this.leg1PnlAccounting = 0;
        this.leg1PriceAccounting = 0;
        this.leg1PrincipalExchanged = '';
        this.leg1RefForward = '';
        this.leg1Spread = 0;
        this.leg1ZSpread = 0;

        this.leg2Amount = 0;
        this.leg2BasicCurve = 0;
        this.leg2BondCurrency = '';
        this.leg2AgainstCurrency = '';
        this.leg2BondIssueDate = '';
        this.leg2BondMaturityDate = '';
        this.leg2BondPrice = 0;
        this.leg2CounterParty = '';
        this.leg2CouponFrequency = 0;
        this.leg2Currency = '';
        this.leg2DisCurve = '';
        this.leg2FixedRateCoupon = 0;
        this.leg2FloatingRate = 0;
        this.leg2HaircutAfterPricing = 0;
        this.leg2Id = '';
        this.leg2IrsNotional = 0;//ATTN
        this.leg2IssueDate = '';
        this.leg2LegType = '';
        this.leg2MaturityDate = '';
        this.leg2Notional = 0;
        this.leg2NpvUsd = 0;
        this.leg2PayBackNotional = 0;
        this.leg2PayNotional = 0;
        this.leg2BondNotional = 0;
        this.leg2FxRate = 0;
        this.leg2RepoRate = 0;
        this.leg2BondNotional = 0;
        this.leg2PnlAccounting = 0;
        this.leg2PriceAccounting = 0;
        this.leg2PrincipalExchanged = '';
        this.leg2RefForward = '';
        this.leg2Spread = 0;
        this.leg2ZSpread = 0;

        this.vaR_PFE = 0;
        this.vaR_PLE = 0;
    }
}